/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import i18next from 'i18next';
import { updateOptions, updateSelectedOption } from './autocomplete.slice';
import autocompleteApi from '../../../api/autocomplete.api';
import { showAlertError } from '../alerts/alerts.slice';
import { createFOAsyncThunk } from '../../helpers/thunk.helpers';
import { createMessage } from '../alerts/alerts.helper';

/* Thunks */
const fetchAllAutocompleteOptions = async ({ url, category, name }, dispatch) => {
  const response = await autocompleteApi.getAutocompleteList(url, category);

  if (response) {
    const autocompleteOptions = response[name];
    dispatch(updateOptions({ autocompleteOptions, name }));
    return autocompleteOptions;
  }
  return [];
};

const fetchSelectedOptionDetails = async ({ url, category, code, name }, dispatch) => {
  try {
    const response = await autocompleteApi.getAutocompleteDetailsByCode(url, category, code);
    if (response) dispatch(updateSelectedOption({ response, name }));
  } catch (err) {
    dispatch(showAlertError(createMessage(i18next.t('error.page.generic.title'), err)));
    dispatch(updateSelectedOption({ response: null, name }));
  }
};

const fetchIsSelectedOptionValid = async ({ url, option }) => {
  const response = await autocompleteApi.getValidAutocompleteInput(url, option);
  return response;
};

export const getAutocompleteOptions = createFOAsyncThunk(
  'representatives/fetchAllAutocompleteOptions',
  async (autocompleteReqObject, { dispatch }) => {
    return fetchAllAutocompleteOptions(autocompleteReqObject, dispatch);
  },
);

export const getSelectedOptionDetails = createFOAsyncThunk(
  'representatives/fetchSelectedOptionDetails',
  async (autocompleteReqObject, { dispatch }) => {
    return fetchSelectedOptionDetails(autocompleteReqObject, dispatch);
  },
);

export const isSelectedOptionValid = createFOAsyncThunk(
  'applicants/isSelectedOptionValid',
  async (autocompleteReqObject, { dispatch }) => {
    return fetchIsSelectedOptionValid(autocompleteReqObject, dispatch);
  },
);
